module.exports = __webpack_public_path__ + "img/1.524321ff.jpg";